<!-- Translated: no -->
<template>
  <div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import API from '@/classes/API';
import UpdateAddress from '@/components/parts/UpdateAddress';

export default {
  methods: {
    ...mapMutations([
      'openModal',
    ]),
  },
  async mounted() {
    if (!this.alreadyLoaded) {
      const { data } = await API.get(
        `/account/get-user-fields-for-update?checkout_session_id=${this.$route.query.checkout_session_id}`,
      );

      if (Object.keys(data || {}).length) {
        this.openModal(['GeneralModal', {
          changes: data,
          embed: UpdateAddress,
        }]);
      }
    }
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
</style>



// WEBPACK FOOTER //
// CheckUpdateAddress.vue?b6421a14